export default __webpack_public_path__ + "static/media/water3.7ba61854.png";